import { useState, FC } from 'react';
import { Box, TextField, Alert } from '@mui/material';
import { Button } from '../../components';
import { sendSMSText } from '../../fetch';

interface IMFATextOptionProps {
  buttonText: string;
  isButtonDisabled?: boolean;
  isLoading?: boolean;
  textFieldLabel: string;
  textFieldValue: string;
  handleChange: (val: string) => void;
  alertText?: string;
  handleButtonClick: (e: any) => void;
  authId?: string | number;
  isTextOption?: boolean;
}

export const MFATextOption: FC<IMFATextOptionProps> = ({
  buttonText,
  isButtonDisabled,
  isLoading,
  textFieldLabel,
  textFieldValue,
  handleChange,
  alertText,
  handleButtonClick,
  authId,
  isTextOption
}) => {
  const [isSending, setIsSending] = useState(false);
  return (
    <>
      {alertText && (
        <Box mt={1}>
          <Alert severity="info">{alertText}</Alert>
        </Box>
      )}
      <Box mt={1}>
        <TextField
          fullWidth
          id="input-id"
          label={textFieldLabel}
          margin="none"
          required
          type="text"
          onChange={e => {
            if (textFieldLabel === 'Code') {
              return handleChange(e.target.value.trim());
            }
            handleChange(e.target.value);
          }}
          value={textFieldValue}
        />
      </Box>
      <Box mt={1}>
        <Button
          id="send-code"
          fullWidth
          type="submit"
          loading={isLoading ? 'Loading...' : ''}
          variant="contained"
          color="primary"
          size="large"
          disabled={isButtonDisabled}
          onClick={handleButtonClick}
        >
          {isLoading ? '' : buttonText}
        </Button>
      </Box>
      {textFieldLabel === 'Code' && isTextOption && (
        <Box mt={1}>
          <Button
            id="resend-code"
            fullWidth
            type="button"
            loading={isSending ? 'Sending...' : ''}
            variant="contained"
            color="secondary"
            size="large"
            disabled={isSending}
            onClick={async () => {
              try {
                setIsSending(true);
                await sendSMSText(authId);
              } catch (error) {
              } finally {
                setIsSending(false);
              }
            }}
          >
            Resend Code
          </Button>
        </Box>
      )}
    </>
  );
};
